export const checkTokenExpired = token => {
    let status = 'Active';
    let result = true;
    if (!token) {
        status = 'error';
        result = false;
        return { status, result };
    }
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    const decoded = JSON.parse(window.atob(base64));
    const currentDate = new Date();
    const expirationDate = new Date(decoded.exp * 1000);
    const renewalDate = new Date(decoded.renewalDate * 1000);

    if (currentDate > expirationDate) {
        status = 'Expired';
        result = false;
    } else if (currentDate > renewalDate) {
        status = 'Renewal Required';
    }
    return { status, result };
};
